import { SelectItem } from 'primeng/api';

export interface Contact {
  id: number;
  name: string;
  role: string;
  phone: string;
  email: string;
  checked?: boolean;
  nameType?: number;
  phoneType?: string;
}

export const CONTACT_NAME_TYPES: SelectItem[] = [
  {
    label: 'Name',
    value: '1',
  },
  {
    label: 'Familiar Name',
    value: '2',
  },
];
